// extracted by mini-css-extract-plugin
export default {"error":"c24f8626d362","title":"a94da19810c8","details":"b69235076c3a"};